import React from 'react';
import { useQuery } from 'react-query';
import { getIndexes, getOrders } from 'config/api';
import { ComparisonBetweenIndexAndAsset } from './ComparisonBetweenIndexAndAsset';
import { RealizedProfitAndLoss } from './RealizedProfitAndLoss';
import * as consts from 'config/consts';

const Title: React.FC<Record<string, unknown>> = () => (
  <div className="h-22.5 flex items-end p-4 text-lg font-bold text-bluegray-700 leading-tight">
    <img
      src="/static/images/report/icon-asset.svg"
      alt=""
      className="w-4 h-4 mr-2"
    />
    あなたの資産運用レポート
  </div>
);

export const ManagedAssetsReport = ({
  from,
  queryFrom,
  queryTo,
}: {
  from: number;
  queryFrom: string;
  queryTo: string;
}) => {
  const {
    data: indexesData,
    isFetching: indexesIsFetching,
    isRefetching: indexesIsRefetching,
  } = useQuery('monthlyIndxes', () => fetchIndexes(queryFrom, queryTo), {
    refetchOnWindowFocus: false,
  });

  const {
    data: ordersData,
    isFetching: ordersIsFetching,
    isRefetching: ordersIsRefetching,
  } = useQuery('monthlyOrders', () => fetchOrders(queryFrom, queryTo), {
    refetchOnWindowFocus: false,
  });

  if (
    (indexesIsFetching && indexesIsRefetching) ||
    indexesData === null ||
    indexesData === undefined ||
    (ordersIsFetching && ordersIsRefetching) ||
    ordersData === null ||
    ordersData === undefined
  )
    return <></>;

  return (
    <>
      <Title />
      <div className="bg-white">
        {indexesData.length !== 0 && (
          <>
            <ComparisonBetweenIndexAndAsset {...{ Indexes: indexesData }} />
            <div className="section-block-divider"></div>
          </>
        )}
        <RealizedProfitAndLoss {...{ from, Orders: ordersData }} />
      </div>
    </>
  );
};

const fetchIndexes = async (from: string, to: string) => {
  const res_ = await getIndexes(from, to);
  const res = res_.Items.map(item => item).reverse();
  return res;
};

const fetchOrders = async (from: string, to: string) => {
  const res_ = await getOrders(consts.reportType.月次, from, to);
  const res = res_.Items.map(res => {
    return {
      brokerID: res.BrokerID,
      brokerName: res.BrokerName,
      tradeTime: res.TradeTime,
      symbol: res.Symbol,
      symbolName: res.SymbolName,
      accountType: res.AccountType,
      productType: res.ProductType,
      cashMargin: res.CashMargin,
      tradeType: res.TradeType,
      side: res.Side,
      qty: res.Qty,
      price: res.Price,
      openPrice: res.OpenPrice,
      openPriceUSD: res.OpenPriceUSD,
      profitOrLoss: res.ProfitOrLoss,
      profitOrLossUSD: res.ProfitOrLossUSD,
      currencyUnit: res.CurrencyUnit,
    };
  });
  return res;
};
